import api from "./api";
import { markOnboardingTask } from "./onboarding";

// Legacy client-only store — superseded by the backend /watchlist API below,
// kept only so migrateLegacyWatchlist() can move existing users' saved
// listings server-side (once) instead of silently losing them.
const LEGACY_KEY = "immo_watchlist_v1";

function getLegacyWatchlist() {
  try { return JSON.parse(localStorage.getItem(LEGACY_KEY) || "[]"); } catch { return []; }
}

export async function migrateLegacyWatchlist() {
  const legacy = getLegacyWatchlist();
  if (!legacy.length) return;
  await Promise.all(
    legacy.map((l) =>
      api.post("/watchlist", { listing_id: l.id, listing_snapshot: l }).catch(() => {})
    )
  );
  localStorage.removeItem(LEGACY_KEY);
}

export async function getWatchlist() {
  const { data } = await api.get("/watchlist");
  return data.watchlist;
}

export async function addToWatchlist(listing) {
  await api.post("/watchlist", { listing_id: listing.id, listing_snapshot: listing });
  markOnboardingTask("watchlist");
}

export async function removeFromWatchlist(id) {
  await api.delete(`/watchlist/${id}`);
}

export function exportWatchlistMd(items) {
  if (!items.length) return "# Watchlist\n\nNo saved listings.\n";
  const lines = ["# immo-watch · Watchlist\n"];
  for (const l of items) {
    lines.push(`## ${l.title}`);
    lines.push(`**Zone:** ${l.zone} · **Faktor:** ${l.faktor} · **Lage:** ${l.lage_grade}`);
    lines.push(`- Market: ${l.market_name} (${l.country})`);
    lines.push(`- Price: €${(l.price || 0).toLocaleString()} (${l.price_per_sqm || "—"} €/m²)`);
    lines.push(`- Size: ${l.size_m2} m² · ${l.rooms} Zi`);
    lines.push(`- Net rent: €${Math.round((l.annual_net_rent || 0) / 12)}/mo · Cashflow: ${l.monthly_cashflow != null ? `${l.monthly_cashflow >= 0 ? "+" : ""}€${l.monthly_cashflow}/mo` : "—"}`);
    lines.push(`- Saved: ${new Date(l.added_at).toLocaleDateString("en-GB")}`);
    lines.push(`- [Source](${l.url})\n`);
  }
  return lines.join("\n");
}
